import { createSlice } from "@reduxjs/toolkit";

const initialState = false;

const buttonEffectSlice = createSlice({
    name: "buttonEffect",
    initialState,
    reducers: {
        buttonEffectSetTrue: (state) => {
            return true;
        },
        buttonEffectSetFalse: (state) => {
            return false;
        },
    },
});
export const { buttonEffectSetTrue, buttonEffectSetFalse } = buttonEffectSlice.actions;
export default buttonEffectSlice.reducer;
